import {
	calculaValorFinalProduto,
	calculaValorUnitarioFinalProduto,
} from "./Monetario";

export function carregaProdutos(jsonDadosModelo, gruposDeProdutosLista) {
	console.log("Json do modelo", jsonDadosModelo);
	let produtosIndisponiveis = [];
	let produtosAlteracaoValor = [];
	//Loop nos produtos
	const produtos = jsonDadosModelo.produtos.map((item) => {
		// O item existe, não esta nulo
		if (item) {
			// console.log("item", item);
			// Verifica se o produto ainda esta disnonível.
			const produtoDisponivel = gruposDeProdutosLista.find(
				(p) => p.id === item.id
			);
			// console.log("produtoDisponivel: ", produtoDisponivel);
			// console.log("produtoDisponivel check: ", produtoDisponivel !== undefined);

			if (produtoDisponivel !== undefined) {
				let id,
					categoria,
					desconto,
					quantidade,
					nome,
					valor_tabela,
					valor_final,
					valor_unitario;

				id = item.id;
				// Categoria
				categoria = item.productGroupCategory
					? item.productGroupCategory
					: null;
				if (!categoria) {
					categoria = item.categoria ? item.categoria : null;
				}

				// Desconto
				desconto =
					item.desconto && typeof item.desconto === "number"
						? item.desconto
						: 0;
				if (!desconto) {
					desconto =
						item.discount && typeof item.discount === "number"
							? item.discount
							: 0;
				}

				// Quantidade
				quantidade =
					item.quantidade && typeof item.quantidade === "number"
						? item.quantidade
						: 1;
				if (!quantidade) {
					quantidade =
						item.amount && typeof item.amount === "number" ? item.amount : 1;
				}

				// Nome
				nome = item.nome ? item.nome : null;
				if (!nome) {
					nome = item.name ? item.name : null;
				}

				console.log(item);
				// Valor Tabela
				valor_tabela = produtoDisponivel.valor_tabela;

				let val = item.valor_tabela ? item.valor_tabela : "";
				if (val === "") val = item.value ? item.value : "";

				if (val === "") val = valor_tabela;

				if (valor_tabela !== val) produtosAlteracaoValor.push(nome);

				// Valor final
				valor_final = calculaValorFinalProduto(
					null,
					desconto,
					valor_tabela,
					quantidade
				);

				// Valor final unitario
				valor_unitario = calculaValorUnitarioFinalProduto(
					null,
					desconto,
					valor_tabela
				);

				return {
					id: id,
					categoria: categoria,
					desconto: desconto,
					quantidade: quantidade,
					nome: nome,
					valor_tabela: valor_tabela,
					valor_final: valor_final,
					valor_unitario: valor_unitario,
				};
			} else {
				let nome = item.nome ? item.nome : null;
				if (!nome) {
					nome = item.name ? item.name : null;
				}
				produtosIndisponiveis.push(nome);
			}
		}
	});

	const produtosLimpos = produtos.filter(function (el) {
		return el != null;
	});

	console.log(produtosAlteracaoValor);
	// console.log("Produtos do modelo final", produtosLimpos);
	return {
		produtos: produtosLimpos,
		produtosIndisponiveis: produtosIndisponiveis,
		produtosAlteracaoValor: produtosAlteracaoValor,
	};
}
